/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "scan_planner";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface PointStatus {
}

export enum PointStatus_Enum {
  INVALID = 0,
  COVERED = 1,
  WILL_BE_COVERED = 2,
  UNREACHABLE = 3,
  UNRECOGNIZED = -1,
}

export function pointStatus_EnumFromJSON(object: any): PointStatus_Enum {
  switch (object) {
    case 0:
    case "INVALID":
      return PointStatus_Enum.INVALID;
    case 1:
    case "COVERED":
      return PointStatus_Enum.COVERED;
    case 2:
    case "WILL_BE_COVERED":
      return PointStatus_Enum.WILL_BE_COVERED;
    case 3:
    case "UNREACHABLE":
      return PointStatus_Enum.UNREACHABLE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PointStatus_Enum.UNRECOGNIZED;
  }
}

export function pointStatus_EnumToJSON(object: PointStatus_Enum): string {
  switch (object) {
    case PointStatus_Enum.INVALID:
      return "INVALID";
    case PointStatus_Enum.COVERED:
      return "COVERED";
    case PointStatus_Enum.WILL_BE_COVERED:
      return "WILL_BE_COVERED";
    case PointStatus_Enum.UNREACHABLE:
      return "UNREACHABLE";
    case PointStatus_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBasePointStatus(): PointStatus {
  return {};
}

export const PointStatus = {
  encode(_: PointStatus, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PointStatus {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePointStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): PointStatus {
    return {};
  },

  toJSON(_: PointStatus): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<PointStatus>, I>>(base?: I): PointStatus {
    return PointStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PointStatus>, I>>(_: I): PointStatus {
    const message = createBasePointStatus();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
